import React from "react";
import { TopicCount } from "../../api/Items";
import { SummaryFilterTypeEnum } from "./SidebarSummary";
import {
  SidebarFilterGroup,
  SidebarGroupedFilters,
} from "./SidebarGroupedFilters";

type Props = {
  topicCount?: TopicCount;
  filteredTopicCount?: TopicCount;
  filtersActive?: boolean;
  selections: string[];
  applyFilterByType: (
    type: SummaryFilterTypeEnum,
    event: React.ChangeEvent<HTMLInputElement>,
    source: string
  ) => void;
};

function filteredTopicCountFor(
  filteredTopicCount: TopicCount | undefined,
  groupId: string,
  label: string
): number | undefined {
  const group = filteredTopicCount?.groups?.find(
    (candidate) => candidate.lens_topics_uuid === groupId
  );
  return group?.labels?.find(
    (topic) => topic.label.toLocaleLowerCase() === label.toLocaleLowerCase()
  )?.count;
}

export const SidebarTopics = ({
  topicCount,
  filteredTopicCount,
  filtersActive = false,
  selections,
  applyFilterByType,
}: Props) => {
  const showFiltered = filtersActive && !!filteredTopicCount;
  const groups: SidebarFilterGroup[] = (topicCount?.groups ?? []).map(
    (group) => ({
      id: group.lens_topics_uuid,
      name: group.name,
      children: (group.labels ?? []).map((topic) => {
        const filtered = filteredTopicCountFor(
          filteredTopicCount,
          group.lens_topics_uuid,
          topic.label
        );
        return {
          id: `${group.lens_topics_uuid}-${topic.topic_group_name}-${topic.label}`,
          label: topic.label,
          value: topic.label,
          count: showFiltered ? filtered ?? 0 : topic.count,
          baselineCount: showFiltered ? topic.count : undefined,
        };
      }),
    })
  );

  return (
    <SidebarGroupedFilters
      groups={groups}
      selectedValues={selections}
      onChange={(event, values) =>
        values.forEach((value) =>
          applyFilterByType(SummaryFilterTypeEnum.topic, event, value)
        )
      }
    />
  );
};
